import { appLogger } from '../utils/datadog';
import { getEmbedSafeHeaders } from './auth';
import blpAuth from './blp-auth';

export interface UploadFontResponse {
	url: string;
	originalName: string;
}

const fileToBase64 = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
};

export const SaveFont = async (
	roomId: number,
	file: File,
	fontAssetId?: number
): Promise<UploadFontResponse | null> => await blpAuth.post({
	host: process.env.REACT_APP_SYNC_HOST,
	url: `/v1/room/${roomId}/font-assets/save/${fontAssetId || 0}`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()},
	body: {
		fontData: await fileToBase64(file),
		name: file.name,
	},
}).catch((err) => {
	const errorMessage = err?.error?.error ?? 'No error specified';
	appLogger.error('error loading fonts: ', err);
	return errorMessage;
}).then((res) => res);

export const LoadFontAssets = async (
	roomId: number
) => blpAuth.get({
	host: process.env.REACT_APP_SYNC_HOST,
	url: `/v1/room/${roomId}/font-assets/load`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()}
}).catch((err) => {
	appLogger.error('error loading fonts: ', err);
	return null;
}).then((res) => res);